import { getGroupOpenedChatIds } from './getGroupOpenedChatIds';
import { TChatGroupId } from '../../../../../types/rest/IRestChatGroup';
import { TChatId } from '../../../../../types/rest/IRestChat';

export const getGroupOpenedChatId = (
    groupId: TChatGroupId
): TChatId => {
    return getGroupOpenedChatIds()[groupId];
}
